import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISORSA } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIdOlRisorsaState extends EntityState<IID_OL_RISORSA, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_RISORSA })
export class IIDolRisorsaStore extends EntityStore<IIdOlRisorsaState> {
  constructor() {
    super([]);
  }
}